import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";

// Definición de defaults

export const defaultBuscarLibroExpedientesConcluidosResponse: BuscarLibroExpedientesConcluidosResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroExpedientesConcluidos: BuscarLibroExpedientesConcluidos = { idAutoridad: 0, numeroReferencia: '' };

export const defaultLibroExpedientesConcluidos: LibroExpedientesConcluidosProps = { 
    idLibroExpedienteConcluido: 0,
    idExpediente:               0,
    numeroExpediente:           '',
    tipoJuicio:                 '',
    motivoConclusion:           '',
    observaciones:              '',
    idAcuerdo:                  null,
    documentoAcuerdo:           '',
    expediente:                 defaultExpediente,
};

// Creación de interfaces

export interface LibroExpedientesConcluidosProps {
    idLibroExpedienteConcluido: number;
    idExpediente:               number;
    numeroExpediente:           string;
    tipoJuicio:                 string;
    motivoConclusion:           string;
    observaciones:              string;
    idAcuerdo:                  number | null;
    documentoAcuerdo:           string;
    fechaConcluye?:             Date;
    expediente:                 ExpedienteProps;
}

export interface BuscarLibroExpedientesConcluidos {
    idAutoridad:        number;
    numeroReferencia:   string;
}

export interface BuscarLibroExpedientesConcluidosParams extends PaginacionProps, BuscarLibroExpedientesConcluidos { }

export interface BuscarLibroExpedientesConcluidosResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroExpedientesConcluidosProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
}